/**
 * @fileoverview Application entry point.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from '@/App';
import { initializeTheme } from '@/lib/stores/themeStore';
import '@/lib/i18n';
import '@/styles/globals.css';

// Initialize theme before render to prevent flash
initializeTheme();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
